import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Action = {
  __typename?: 'Action';
  activated: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  day?: Maybe<Scalars['Int']['output']>;
  defined: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  edges?: Maybe<Array<Maybe<Edge>>>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<Node>>>;
  profile?: Maybe<Profile>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  time?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<ActionType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ActionConnection = {
  __typename?: 'ActionConnection';
  edges: Array<Maybe<Action>>;
  pageInfo: PageInfo;
};

export enum ActionFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

export type ActionInput = {
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  defined?: InputMaybe<Scalars['Boolean']['input']>;
  edges?: InputMaybe<Array<InputMaybe<EdgeInput>>>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nodes?: InputMaybe<Array<InputMaybe<NodeInput>>>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  time?: InputMaybe<Scalars['Time']['input']>;
  type?: InputMaybe<ActionType>;
};

export enum ActionType {
  ColdMail = 'COLD_MAIL'
}

export type Business = {
  __typename?: 'Business';
  avatar?: Maybe<Media>;
  categories?: Maybe<Array<Maybe<Category>>>;
  collaborationTypes?: Maybe<Array<Maybe<CollaborationType>>>;
  countries?: Maybe<Array<Maybe<Country>>>;
  coverPhoto?: Maybe<Media>;
  createdAt: Scalars['DateTime']['output'];
  customerGender?: Maybe<Scalars['String']['output']>;
  customerUnitPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  registrationMedia?: Maybe<Media>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  snsUrl?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<State>>>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BusinessConnection = {
  __typename?: 'BusinessConnection';
  edges: Array<Maybe<Business>>;
  pageInfo: PageInfo;
};

export type BusinessInput = {
  avatarInput?: InputMaybe<MediaInput>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  coverPhotoInput?: InputMaybe<MediaInput>;
  customerGender?: InputMaybe<Scalars['String']['input']>;
  customerUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  mediaInputs?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationMediaInput?: InputMaybe<MediaInput>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  snsUrl?: InputMaybe<Scalars['String']['input']>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Category = {
  __typename?: 'Category';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  names?: Maybe<Array<Maybe<CategoryName>>>;
  order: Scalars['Int']['output'];
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  edges: Array<Maybe<Category>>;
  pageInfo: PageInfo;
};

export type CategoryInput = {
  active: Scalars['Boolean']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
};

export type CategoryName = {
  __typename?: 'CategoryName';
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CategoryNameInput = {
  categoryId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type City = {
  __typename?: 'City';
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  stateCode?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  wikiDataId?: Maybe<Scalars['String']['output']>;
};

export type CityConnection = {
  __typename?: 'CityConnection';
  edges: Array<Maybe<City>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CityInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  wikiDataId?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationType = {
  __typename?: 'CollaborationType';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  names?: Maybe<Array<Maybe<CollaborationTypeName>>>;
  order: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollaborationTypeConnection = {
  __typename?: 'CollaborationTypeConnection';
  edges: Array<Maybe<CollaborationType>>;
  pageInfo: PageInfo;
};

export type CollaborationTypeInput = {
  active: Scalars['Boolean']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
};

export type CollaborationTypeName = {
  __typename?: 'CollaborationTypeName';
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CollaborationTypeNameInput = {
  collaborationTypeId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Content = {
  __typename?: 'Content';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hashtags?: Maybe<Array<Maybe<Hashtag>>>;
  id: Scalars['ID']['output'];
  media: Media;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  youtube?: Maybe<Youtube>;
};

export enum ContentChannel {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Youtube = 'YOUTUBE'
}

export type ContentConnection = {
  __typename?: 'ContentConnection';
  edges: Array<Maybe<Content>>;
  pageInfo: PageInfo;
};

export type ContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hashtagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mediaInput?: InputMaybe<MediaInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Country = {
  __typename?: 'Country';
  capital?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyName?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  emojiU?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  native?: Maybe<Scalars['String']['output']>;
  numericCode?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  subregion?: Maybe<Subregion>;
  timezones?: Maybe<Scalars['String']['output']>;
  tld?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<Scalars['String']['output']>;
  wikiDataId?: Maybe<Scalars['String']['output']>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  edges: Array<Maybe<Country>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CountryInput = {
  capital?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  currencySymbol?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  emojiU?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  iso2?: InputMaybe<Scalars['String']['input']>;
  iso3?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['String']['input']>;
  numericCode?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  subregionId?: InputMaybe<Scalars['ID']['input']>;
  timezones?: InputMaybe<Scalars['String']['input']>;
  tld?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['String']['input']>;
  wikiDataId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomProfileInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  type: ProfileType;
};

export type Edge = {
  __typename?: 'Edge';
  action?: Maybe<Action>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  edge?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  profile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EdgeInput = {
  edge?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Hashtag = {
  __typename?: 'Hashtag';
  counts: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tag: Scalars['String']['output'];
};

export type HashtagConnection = {
  __typename?: 'HashtagConnection';
  edges: Array<Maybe<Hashtag>>;
  pageInfo: PageInfo;
};

export type HashtagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
};

export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  /** This is provided only when thumbnailFile is uploaded */
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type MediaInput = {
  file: Scalars['Upload']['input'];
  thumbnailFile?: InputMaybe<Scalars['Upload']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Boolean']['output']>;
  addHashtag: Hashtag;
  addSnsChannel: SnsChannel;
  createAction: Action;
  createBusinessProfile: Profile;
  createCustomProfilePicks: Scalars['Boolean']['output'];
  createUser: User;
  deleteAction: Action;
  deleteActions: Scalars['Boolean']['output'];
  deleteCategoryNameAsAdmin: Scalars['Boolean']['output'];
  deleteCollaborationTypeNameAsAdmin: Scalars['Boolean']['output'];
  deleteContent: Content;
  deleteHashtagAsAdmin: Scalars['Boolean']['output'];
  deleteProfileMedia: Profile;
  deleteRegionAsAdmin: Scalars['Boolean']['output'];
  deleteTagAsAdmin: Scalars['Boolean']['output'];
  preRegister: Profile;
  publishContent: Content;
  removeSnsChannel: Scalars['Boolean']['output'];
  resign: Scalars['Boolean']['output'];
  toggleActivateAction: Action;
  toggleArchiveAction: Action;
  toggleProfilePick: Profile;
  updateAction: Action;
  updateBusinessProfile: Profile;
  updateCategoryAsAdmin: Category;
  updateCategoryNamesAsAdmin: Category;
  updateCityAsAdmin: City;
  updateCollaborationTypeAsAdmin: CollaborationType;
  updateCollaborationTypeNamesAsAdmin: CollaborationType;
  updateContent: Content;
  updateCountryAsAdmin: Country;
  updateMyUser: User;
  updateRegionAsAdmin: Region;
  updateRoleAsAdmin: Role;
  updateStateAsAdmin: State;
  updateSubregionAsAdmin: Subregion;
};


export type MutationAddHashtagArgs = {
  tag: Scalars['String']['input'];
};


export type MutationAddSnsChannelArgs = {
  refreshToken: Scalars['String']['input'];
  snsType: SnsType;
};


export type MutationCreateActionArgs = {
  actionInput: ActionInput;
};


export type MutationCreateBusinessProfileArgs = {
  businessInput: BusinessInput;
  email?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};


export type MutationCreateCustomProfilePicksArgs = {
  customProfileInputs: Array<InputMaybe<CustomProfileInput>>;
  pickerProfileId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationDeleteActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationDeleteActionsArgs = {
  actionIds: Array<Scalars['ID']['input']>;
  profileId: Scalars['ID']['input'];
};


export type MutationDeleteCategoryNameAsAdminArgs = {
  categoryNameId: Scalars['ID']['input'];
};


export type MutationDeleteCollaborationTypeNameAsAdminArgs = {
  collaborationTypeNameId: Scalars['ID']['input'];
};


export type MutationDeleteContentArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationDeleteHashtagAsAdminArgs = {
  hashtagId: Scalars['ID']['input'];
};


export type MutationDeleteProfileMediaArgs = {
  mediaIds: Array<InputMaybe<Scalars['ID']['input']>>;
  profileId: Scalars['ID']['input'];
};


export type MutationDeleteRegionAsAdminArgs = {
  regionId: Scalars['ID']['input'];
};


export type MutationDeleteTagAsAdminArgs = {
  tagId: Scalars['ID']['input'];
};


export type MutationPreRegisterArgs = {
  customProfileInput: CustomProfileInput;
};


export type MutationPublishContentArgs = {
  channels: Array<InputMaybe<ContentChannel>>;
  contentId: Scalars['ID']['input'];
};


export type MutationRemoveSnsChannelArgs = {
  snsChannelId: Scalars['ID']['input'];
};


export type MutationResignArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleActivateActionArgs = {
  actionId: Scalars['ID']['input'];
  activated: Scalars['Boolean']['input'];
};


export type MutationToggleArchiveActionArgs = {
  actionId: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
};


export type MutationToggleProfilePickArgs = {
  picked: Scalars['Boolean']['input'];
  pickedProfileId: Scalars['ID']['input'];
  pickerProfileId: Scalars['ID']['input'];
};


export type MutationUpdateActionArgs = {
  actionInput: ActionInput;
};


export type MutationUpdateBusinessProfileArgs = {
  avatarDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  businessInput: BusinessInput;
  coverPhotoDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateCategoryAsAdminArgs = {
  categoryInput: CategoryInput;
};


export type MutationUpdateCategoryNamesAsAdminArgs = {
  categoryId: Scalars['ID']['input'];
  categoryNameInputs: Array<CategoryNameInput>;
};


export type MutationUpdateCityAsAdminArgs = {
  cityInput: CityInput;
};


export type MutationUpdateCollaborationTypeAsAdminArgs = {
  collaborationTypeInput: CollaborationTypeInput;
};


export type MutationUpdateCollaborationTypeNamesAsAdminArgs = {
  collaborationTypeId: Scalars['ID']['input'];
  collaborationTypeNameInputs: Array<InputMaybe<CollaborationTypeNameInput>>;
};


export type MutationUpdateContentArgs = {
  contentInput: ContentInput;
};


export type MutationUpdateCountryAsAdminArgs = {
  countryInput: CountryInput;
};


export type MutationUpdateMyUserArgs = {
  userInput: UserInput;
};


export type MutationUpdateRegionAsAdminArgs = {
  regionInput: RegionInput;
};


export type MutationUpdateRoleAsAdminArgs = {
  roleInput: RoleInput;
};


export type MutationUpdateStateAsAdminArgs = {
  stateInput: StateInput;
};


export type MutationUpdateSubregionAsAdminArgs = {
  subregionInput: SubregionInput;
};

export type Node = {
  __typename?: 'Node';
  action?: Maybe<Action>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  id: Scalars['ID']['output'];
  node?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NodeInput = {
  id: Scalars['ID']['input'];
  node?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type Profile = {
  __typename?: 'Profile';
  business?: Maybe<Business>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  picked?: Maybe<Scalars['Boolean']['output']>;
  type: ProfileType;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<Maybe<ProfileUser>>>;
};

export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  edges: Array<Maybe<Profile>>;
  pageInfo: PageInfo;
};

export enum ProfileType {
  Business = 'BUSINESS',
  Creator = 'CREATOR'
}

export type ProfileUser = {
  __typename?: 'ProfileUser';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  profile: Profile;
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type ProfileUserConnection = {
  __typename?: 'ProfileUserConnection';
  edges: Array<Maybe<ProfileUser>>;
  pageInfo: PageInfo;
};

export type ProfileUserInput = {
  profileId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['Boolean']['output']>;
  checkUniqueProfileEmail: Scalars['Boolean']['output'];
  getAction: Action;
  getActionsByProfileId: ActionConnection;
  getAllHashtags: HashtagConnection;
  getBusinessProfiles: ProfileConnection;
  getCategories: CategoryConnection;
  getCategory: Category;
  getCities: CityConnection;
  getCitiesByCountry: CityConnection;
  getCitiesByState: CityConnection;
  getCity?: Maybe<City>;
  getCollaborationType: CollaborationType;
  getCollaborationTypes: CollaborationTypeConnection;
  getContent: Content;
  getCountries: CountryConnection;
  getCountriesByRegion: CountryConnection;
  getCountriesBySubregion: CountryConnection;
  getCountry?: Maybe<Country>;
  getMyContents: ContentConnection;
  getMyProfiles: Array<Maybe<Profile>>;
  getMySnsChannel: SnsChannel;
  getMySnsChannels: Array<Maybe<SnsChannel>>;
  getMyUser?: Maybe<User>;
  getProfile: Profile;
  getProfilePicks: ProfileConnection;
  getRegion?: Maybe<Region>;
  getRegions?: Maybe<Array<Maybe<Region>>>;
  getRoles: Array<Maybe<Role>>;
  getState?: Maybe<State>;
  getStates: StateConnection;
  getStatesByCountry: StateConnection;
  getSubregion?: Maybe<Subregion>;
  getSubregions: SubregionConnection;
  getSubregionsByRegion: SubregionConnection;
  getTags: TagConnection;
  getUnpickedCustomProfileCount: Scalars['Int']['output'];
  getUser: User;
  getUserContentsAsAdmin: ContentConnection;
  getUserSnsChannels: Array<Maybe<SnsChannel>>;
  getUsersAsAdmin: UserConnection;
  searchHashtags: HashtagConnection;
  searchTags: TagConnection;
};


export type QueryCheckUniqueProfileEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetActionArgs = {
  actionId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetActionsByProfileIdArgs = {
  activated: ActionFilter;
  after?: InputMaybe<Scalars['String']['input']>;
  defined: ActionFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActionType>;
};


export type QueryGetAllHashtagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBusinessProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetCategoriesArgs = {
  activeOnly: Scalars['Boolean']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetCitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCitiesByCountryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCitiesByStateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stateId: Scalars['ID']['input'];
};


export type QueryGetCityArgs = {
  cityId: Scalars['ID']['input'];
};


export type QueryGetCollaborationTypeArgs = {
  collaborationTypeId: Scalars['ID']['input'];
};


export type QueryGetCollaborationTypesArgs = {
  activeOnly: Scalars['Boolean']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetContentArgs = {
  contentId: Scalars['ID']['input'];
};


export type QueryGetCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCountriesByRegionArgs = {
  regionId: Scalars['ID']['input'];
};


export type QueryGetCountriesBySubregionArgs = {
  subregionId: Scalars['ID']['input'];
};


export type QueryGetCountryArgs = {
  countryId: Scalars['ID']['input'];
};


export type QueryGetMyContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMySnsChannelArgs = {
  snsChannelId: Scalars['ID']['input'];
};


export type QueryGetProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryGetProfilePicksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetRegionArgs = {
  regionId: Scalars['ID']['input'];
};


export type QueryGetRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStateArgs = {
  stateId: Scalars['ID']['input'];
};


export type QueryGetStatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStatesByCountryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSubregionArgs = {
  subregionId: Scalars['ID']['input'];
};


export type QueryGetSubregionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSubregionsByRegionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
};


export type QueryGetTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUnpickedCustomProfileCountArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  pickerProfileId: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserContentsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryGetUserSnsChannelsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUsersAsAdminArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchHashtagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<Scalars['String']['output']>;
  wikiDataId?: Maybe<Scalars['String']['output']>;
};

export type RegionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['String']['input']>;
  wikiDataId?: InputMaybe<Scalars['String']['input']>;
};

export type Role = {
  __typename?: 'Role';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RoleInput = {
  active: Scalars['Boolean']['input'];
  level: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type SnsChannel = {
  __typename?: 'SNSChannel';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  thumbnailUri?: Maybe<Scalars['String']['output']>;
  type: SnsType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export enum SnsType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Youtube = 'YOUTUBE'
}

export type State = {
  __typename?: 'State';
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StateConnection = {
  __typename?: 'StateConnection';
  edges: Array<Maybe<State>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Subregion = {
  __typename?: 'Subregion';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  translations?: Maybe<Scalars['String']['output']>;
  wikiDataId?: Maybe<Scalars['String']['output']>;
};

export type SubregionConnection = {
  __typename?: 'SubregionConnection';
  edges: Array<Maybe<Subregion>>;
  pageInfo: PageInfo;
};

export type SubregionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  translations?: InputMaybe<Scalars['String']['input']>;
  wikiDataId?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tag: Scalars['String']['output'];
};

export type TagConnection = {
  __typename?: 'TagConnection';
  edges: Array<Maybe<Tag>>;
  pageInfo: PageInfo;
};

export type TagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Media>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownedProfiles: Array<Maybe<Profile>>;
  phone?: Maybe<Scalars['String']['output']>;
  profiles: Array<Maybe<ProfileUser>>;
  resignReason?: Maybe<Scalars['String']['output']>;
  snsChannels: Array<Maybe<SnsChannel>>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<Maybe<User>>;
  pageInfo: PageInfo;
};

export type UserInput = {
  avatarInput?: InputMaybe<MediaInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Youtube = {
  __typename?: 'Youtube';
  allowEmbedding: Scalars['Boolean']['output'];
  categoryId: Scalars['String']['output'];
  content: Content;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  license?: Maybe<Scalars['String']['output']>;
  madeForKids: Scalars['Boolean']['output'];
  notifySubscribers: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: Scalars['String']['output'];
};

export type GetActionQueryVariables = Exact<{
  actionId: Scalars['ID']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetActionQuery = { __typename?: 'Query', getAction: { __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, time?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } };

export type GetActionsByProfileIdQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  defined: ActionFilter;
  activated: ActionFilter;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActionType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetActionsByProfileIdQuery = { __typename?: 'Query', getActionsByProfileId: { __typename?: 'ActionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } | null> } };

export type CreateActionMutationVariables = Exact<{
  actionInput: ActionInput;
}>;


export type CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } };

export type UpdateActionMutationVariables = Exact<{
  actionInput: ActionInput;
}>;


export type UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } };

export type DeleteActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
}>;


export type DeleteActionMutation = { __typename?: 'Mutation', deleteAction: { __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } };

export type DeleteActionsMutationVariables = Exact<{
  actionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
}>;


export type DeleteActionsMutation = { __typename?: 'Mutation', deleteActions: boolean };

export type ToggleArchiveActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type ToggleArchiveActionMutation = { __typename?: 'Mutation', toggleArchiveAction: { __typename?: 'Action', id: string, type?: ActionType | null, name?: string | null, defined: boolean, activated: boolean, startAt?: any | null, endAt?: any | null, interval?: number | null, day?: number | null, createdAt: any, updatedAt: any, deletedAt?: any | null, archivedAt?: any | null, profile?: { __typename?: 'Profile', id: string } | null, creator?: { __typename?: 'User', id: string, name?: string | null, username?: string | null, email: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, node?: string | null } | null> | null, edges?: Array<{ __typename?: 'Edge', id: string, edge?: string | null } | null> | null } };

export type GetCountriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCountriesQuery = { __typename?: 'Query', getCountries: { __typename?: 'CountryConnection', pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } | null, edges: Array<{ __typename?: 'Country', id: string, name?: string | null, iso2?: string | null, emoji?: string | null, emojiU?: string | null, flag?: string | null } | null> } };

export type GetStatesByCountryQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStatesByCountryQuery = { __typename?: 'Query', getStatesByCountry: { __typename?: 'StateConnection', pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } | null, edges: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> } };

export type GetCategoriesQueryVariables = Exact<{
  activeOnly: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories: { __typename?: 'CategoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, languageCode?: string | null, name?: string | null } | null> | null } | null> } };

export type GetCollaborationTypesQueryVariables = Exact<{
  activeOnly: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCollaborationTypesQuery = { __typename?: 'Query', getCollaborationTypes: { __typename?: 'CollaborationTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, languageCode?: string | null, name?: string | null } | null> | null } | null> } };

export type SearchHashtagsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchHashtagsQuery = { __typename?: 'Query', searchHashtags: { __typename?: 'HashtagConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Hashtag', id: string, tag: string, counts: number } | null> } };

export type AddHashtagMutationVariables = Exact<{
  tag: Scalars['String']['input'];
}>;


export type AddHashtagMutation = { __typename?: 'Mutation', addHashtag: { __typename?: 'Hashtag', id: string, tag: string, counts: number } };

export type GetMyProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProfilesQuery = { __typename?: 'Query', getMyProfiles: Array<{ __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } | null> };

export type GetMyCurrentProfileQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetMyCurrentProfileQuery = { __typename?: 'Query', getProfile: { __typename?: 'Profile', id: string, business?: { __typename?: 'Business', id: string, name?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null } | null } };

export type GetProfileQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileQuery = { __typename?: 'Query', getProfile: { __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, picked?: boolean | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } };

export type GetBusinessProfilesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBusinessProfilesQuery = { __typename?: 'Query', getBusinessProfiles: { __typename?: 'ProfileConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, picked?: boolean | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } | null> } };

export type GetProfilePicksQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  collaborationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfilePicksQuery = { __typename?: 'Query', getProfilePicks: { __typename?: 'ProfileConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, picked?: boolean | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string, name?: string | null, username?: string | null } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null } | null> } };

export type GetUnpickedCustomProfileCountQueryVariables = Exact<{
  pickerProfileId: Scalars['ID']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetUnpickedCustomProfileCountQuery = { __typename?: 'Query', getUnpickedCustomProfileCount: number };

export type CheckUniqueProfileEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckUniqueProfileEmailQuery = { __typename?: 'Query', checkUniqueProfileEmail: boolean };

export type CreateBusinessProfileMutationVariables = Exact<{
  businessInput: BusinessInput;
  roleId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type CreateBusinessProfileMutation = { __typename?: 'Mutation', createBusinessProfile: { __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } };

export type UpdateBusinessProfileMutationVariables = Exact<{
  profileId: Scalars['ID']['input'];
  businessInput: BusinessInput;
  email: Scalars['String']['input'];
  coverPhotoDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  avatarDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBusinessProfileMutation = { __typename?: 'Mutation', updateBusinessProfile: { __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } };

export type DeleteProfileMediaMutationVariables = Exact<{
  profileId: Scalars['ID']['input'];
  mediaIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteProfileMediaMutation = { __typename?: 'Mutation', deleteProfileMedia: { __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, createdAt: any, updatedAt: any, owner?: { __typename?: 'User', id: string } | null, business?: { __typename?: 'Business', id: string, name?: string | null, url?: string | null, ownerName?: string | null, summary?: string | null, introduction?: string | null, phone?: string | null, createdAt: any, updatedAt: any, profile?: { __typename?: 'Profile', id: string } | null, coverPhoto?: { __typename?: 'Media', id: string, uri: string } | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null, media?: Array<{ __typename?: 'Media', id: string, uri: string } | null> | null, countries?: Array<{ __typename?: 'Country', id: string, name?: string | null } | null> | null, states?: Array<{ __typename?: 'State', id: string, name?: string | null, stateCode?: string | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, tag: string } | null> | null, collaborationTypes?: Array<{ __typename?: 'CollaborationType', id: string, iconUrl?: string | null, active: boolean, order: number, names?: Array<{ __typename?: 'CollaborationTypeName', id: string, language?: string | null, languageCode?: string | null, name?: string | null } | null> | null } | null> | null } | null, users?: Array<{ __typename?: 'ProfileUser', id: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null }, role?: { __typename?: 'Role', id: string, level: string } | null } | null> | null } };

export type ToggleProfilePickMutationVariables = Exact<{
  pickerProfileId: Scalars['ID']['input'];
  pickedProfileId: Scalars['ID']['input'];
  picked: Scalars['Boolean']['input'];
}>;


export type ToggleProfilePickMutation = { __typename?: 'Mutation', toggleProfilePick: { __typename?: 'Profile', id: string, picked?: boolean | null } };

export type CreateCustomProfilePicksMutationVariables = Exact<{
  pickerProfileId: Scalars['ID']['input'];
  customProfileInputs: Array<InputMaybe<CustomProfileInput>> | InputMaybe<CustomProfileInput>;
}>;


export type CreateCustomProfilePicksMutation = { __typename?: 'Mutation', createCustomProfilePicks: boolean };

export type PreRegisterMutationVariables = Exact<{
  customProfileInput: CustomProfileInput;
}>;


export type PreRegisterMutation = { __typename?: 'Mutation', preRegister: { __typename?: 'Profile', id: string, type: ProfileType, email?: string | null, createdAt: any, updatedAt: any, business?: { __typename?: 'Business', id: string, name?: string | null } | null } };

export type GetMySnsChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySnsChannelsQuery = { __typename?: 'Query', getMySnsChannels: Array<{ __typename?: 'SNSChannel', id: string, type: SnsType, name?: string | null, thumbnailUri?: string | null, createdAt: any, updatedAt: any } | null> };

export type AddSnsChannelMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
  snsType: SnsType;
}>;


export type AddSnsChannelMutation = { __typename?: 'Mutation', addSnsChannel: { __typename?: 'SNSChannel', id: string, type: SnsType, name?: string | null, refreshToken?: string | null, accessToken?: string | null, thumbnailUri?: string | null, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string } } };

export type SearchTagsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchTagsQuery = { __typename?: 'Query', searchTags: { __typename?: 'TagConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'Tag', id: string, tag: string, count: number } | null> } };

export type GetMyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUserQuery = { __typename?: 'Query', getMyUser?: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, resignReason?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, snsChannels: Array<{ __typename?: 'SNSChannel', id: string, type: SnsType } | null>, ownedProfiles: Array<{ __typename?: 'Profile', id: string, business?: { __typename?: 'Business', id: string, name?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, name?: string | null, languageCode?: string | null } | null> | null } | null> | null } | null } | null>, profiles: Array<{ __typename?: 'ProfileUser', id: string, profile: { __typename?: 'Profile', business?: { __typename?: 'Business', id: string, name?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null, categories?: Array<{ __typename?: 'Category', id: string, iconUrl?: string | null, names?: Array<{ __typename?: 'CategoryName', id: string, language?: string | null, name?: string | null, languageCode?: string | null } | null> | null } | null> | null } | null } } | null> } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, resignReason?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null } };

export type UpdateMyUserMutationVariables = Exact<{
  userInput: UserInput;
}>;


export type UpdateMyUserMutation = { __typename?: 'Mutation', updateMyUser: { __typename?: 'User', id: string, email: string, name?: string | null, username?: string | null, dateOfBirth?: string | null, phone?: string | null, resignReason?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, uri: string } | null } };

export type ResignMutationVariables = Exact<{
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResignMutation = { __typename?: 'Mutation', resign: boolean };


export const GetActionDocument = gql`
    query GetAction($actionId: ID!, $profileId: ID) {
  getAction(actionId: $actionId, profileId: $profileId) {
    id
    profile {
      id
    }
    creator {
      id
      name
      username
      email
    }
    type
    name
    defined
    activated
    startAt
    endAt
    interval
    day
    time
    nodes {
      id
      node
    }
    edges {
      id
      edge
    }
    createdAt
    updatedAt
    deletedAt
    archivedAt
  }
}
    `;

/**
 * __useGetActionQuery__
 *
 * To run a query within a React component, call `useGetActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetActionQuery(baseOptions: Apollo.QueryHookOptions<GetActionQuery, GetActionQueryVariables> & ({ variables: GetActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
      }
export function useGetActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionQuery, GetActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
        }
export function useGetActionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionQuery, GetActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
        }
export type GetActionQueryHookResult = ReturnType<typeof useGetActionQuery>;
export type GetActionLazyQueryHookResult = ReturnType<typeof useGetActionLazyQuery>;
export type GetActionSuspenseQueryHookResult = ReturnType<typeof useGetActionSuspenseQuery>;
export type GetActionQueryResult = Apollo.QueryResult<GetActionQuery, GetActionQueryVariables>;
export const GetActionsByProfileIdDocument = gql`
    query GetActionsByProfileId($profileId: ID!, $defined: ActionFilter!, $activated: ActionFilter!, $query: String, $type: ActionType, $first: Int, $after: String) {
  getActionsByProfileId(
    profileId: $profileId
    defined: $defined
    activated: $activated
    query: $query
    type: $type
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      profile {
        id
      }
      creator {
        id
        name
        username
        email
      }
      type
      name
      defined
      activated
      startAt
      endAt
      interval
      day
      nodes {
        id
        node
      }
      edges {
        id
        edge
      }
      createdAt
      updatedAt
      deletedAt
      archivedAt
    }
  }
}
    `;

/**
 * __useGetActionsByProfileIdQuery__
 *
 * To run a query within a React component, call `useGetActionsByProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsByProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsByProfileIdQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      defined: // value for 'defined'
 *      activated: // value for 'activated'
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetActionsByProfileIdQuery(baseOptions: Apollo.QueryHookOptions<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables> & ({ variables: GetActionsByProfileIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>(GetActionsByProfileIdDocument, options);
      }
export function useGetActionsByProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>(GetActionsByProfileIdDocument, options);
        }
export function useGetActionsByProfileIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>(GetActionsByProfileIdDocument, options);
        }
export type GetActionsByProfileIdQueryHookResult = ReturnType<typeof useGetActionsByProfileIdQuery>;
export type GetActionsByProfileIdLazyQueryHookResult = ReturnType<typeof useGetActionsByProfileIdLazyQuery>;
export type GetActionsByProfileIdSuspenseQueryHookResult = ReturnType<typeof useGetActionsByProfileIdSuspenseQuery>;
export type GetActionsByProfileIdQueryResult = Apollo.QueryResult<GetActionsByProfileIdQuery, GetActionsByProfileIdQueryVariables>;
export const CreateActionDocument = gql`
    mutation CreateAction($actionInput: ActionInput!) {
  createAction(actionInput: $actionInput) {
    id
    profile {
      id
    }
    creator {
      id
      name
      username
      email
    }
    type
    name
    defined
    activated
    startAt
    endAt
    interval
    day
    nodes {
      id
      node
    }
    edges {
      id
      edge
    }
    createdAt
    updatedAt
    deletedAt
    archivedAt
  }
}
    `;
export type CreateActionMutationFn = Apollo.MutationFunction<CreateActionMutation, CreateActionMutationVariables>;

/**
 * __useCreateActionMutation__
 *
 * To run a mutation, you first call `useCreateActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionMutation, { data, loading, error }] = useCreateActionMutation({
 *   variables: {
 *      actionInput: // value for 'actionInput'
 *   },
 * });
 */
export function useCreateActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionMutation, CreateActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionMutation, CreateActionMutationVariables>(CreateActionDocument, options);
      }
export type CreateActionMutationHookResult = ReturnType<typeof useCreateActionMutation>;
export type CreateActionMutationResult = Apollo.MutationResult<CreateActionMutation>;
export type CreateActionMutationOptions = Apollo.BaseMutationOptions<CreateActionMutation, CreateActionMutationVariables>;
export const UpdateActionDocument = gql`
    mutation UpdateAction($actionInput: ActionInput!) {
  updateAction(actionInput: $actionInput) {
    id
    profile {
      id
    }
    creator {
      id
      name
      username
      email
    }
    type
    name
    defined
    activated
    startAt
    endAt
    interval
    day
    nodes {
      id
      node
    }
    edges {
      id
      edge
    }
    createdAt
    updatedAt
    deletedAt
    archivedAt
  }
}
    `;
export type UpdateActionMutationFn = Apollo.MutationFunction<UpdateActionMutation, UpdateActionMutationVariables>;

/**
 * __useUpdateActionMutation__
 *
 * To run a mutation, you first call `useUpdateActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionMutation, { data, loading, error }] = useUpdateActionMutation({
 *   variables: {
 *      actionInput: // value for 'actionInput'
 *   },
 * });
 */
export function useUpdateActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionMutation, UpdateActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionMutation, UpdateActionMutationVariables>(UpdateActionDocument, options);
      }
export type UpdateActionMutationHookResult = ReturnType<typeof useUpdateActionMutation>;
export type UpdateActionMutationResult = Apollo.MutationResult<UpdateActionMutation>;
export type UpdateActionMutationOptions = Apollo.BaseMutationOptions<UpdateActionMutation, UpdateActionMutationVariables>;
export const DeleteActionDocument = gql`
    mutation DeleteAction($actionId: ID!) {
  deleteAction(actionId: $actionId) {
    id
    profile {
      id
    }
    creator {
      id
      name
      username
      email
    }
    type
    name
    defined
    activated
    startAt
    endAt
    interval
    day
    nodes {
      id
      node
    }
    edges {
      id
      edge
    }
    createdAt
    updatedAt
    deletedAt
    archivedAt
  }
}
    `;
export type DeleteActionMutationFn = Apollo.MutationFunction<DeleteActionMutation, DeleteActionMutationVariables>;

/**
 * __useDeleteActionMutation__
 *
 * To run a mutation, you first call `useDeleteActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionMutation, { data, loading, error }] = useDeleteActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDeleteActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionMutation, DeleteActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionMutation, DeleteActionMutationVariables>(DeleteActionDocument, options);
      }
export type DeleteActionMutationHookResult = ReturnType<typeof useDeleteActionMutation>;
export type DeleteActionMutationResult = Apollo.MutationResult<DeleteActionMutation>;
export type DeleteActionMutationOptions = Apollo.BaseMutationOptions<DeleteActionMutation, DeleteActionMutationVariables>;
export const DeleteActionsDocument = gql`
    mutation DeleteActions($actionIds: [ID!]!, $profileId: ID!) {
  deleteActions(actionIds: $actionIds, profileId: $profileId)
}
    `;
export type DeleteActionsMutationFn = Apollo.MutationFunction<DeleteActionsMutation, DeleteActionsMutationVariables>;

/**
 * __useDeleteActionsMutation__
 *
 * To run a mutation, you first call `useDeleteActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionsMutation, { data, loading, error }] = useDeleteActionsMutation({
 *   variables: {
 *      actionIds: // value for 'actionIds'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteActionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionsMutation, DeleteActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionsMutation, DeleteActionsMutationVariables>(DeleteActionsDocument, options);
      }
export type DeleteActionsMutationHookResult = ReturnType<typeof useDeleteActionsMutation>;
export type DeleteActionsMutationResult = Apollo.MutationResult<DeleteActionsMutation>;
export type DeleteActionsMutationOptions = Apollo.BaseMutationOptions<DeleteActionsMutation, DeleteActionsMutationVariables>;
export const ToggleArchiveActionDocument = gql`
    mutation ToggleArchiveAction($actionId: ID!, $archived: Boolean!) {
  toggleArchiveAction(actionId: $actionId, archived: $archived) {
    id
    profile {
      id
    }
    creator {
      id
      name
      username
      email
    }
    type
    name
    defined
    activated
    startAt
    endAt
    interval
    day
    nodes {
      id
      node
    }
    edges {
      id
      edge
    }
    createdAt
    updatedAt
    deletedAt
    archivedAt
  }
}
    `;
export type ToggleArchiveActionMutationFn = Apollo.MutationFunction<ToggleArchiveActionMutation, ToggleArchiveActionMutationVariables>;

/**
 * __useToggleArchiveActionMutation__
 *
 * To run a mutation, you first call `useToggleArchiveActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchiveActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchiveActionMutation, { data, loading, error }] = useToggleArchiveActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useToggleArchiveActionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArchiveActionMutation, ToggleArchiveActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArchiveActionMutation, ToggleArchiveActionMutationVariables>(ToggleArchiveActionDocument, options);
      }
export type ToggleArchiveActionMutationHookResult = ReturnType<typeof useToggleArchiveActionMutation>;
export type ToggleArchiveActionMutationResult = Apollo.MutationResult<ToggleArchiveActionMutation>;
export type ToggleArchiveActionMutationOptions = Apollo.BaseMutationOptions<ToggleArchiveActionMutation, ToggleArchiveActionMutationVariables>;
export const GetCountriesDocument = gql`
    query GetCountries($first: Int, $after: String) {
  getCountries(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      name
      iso2
      emoji
      emojiU
      flag
    }
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetStatesByCountryDocument = gql`
    query GetStatesByCountry($countryId: ID!, $first: Int, $after: String) {
  getStatesByCountry(countryId: $countryId, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      name
      country {
        id
        name
      }
      stateCode
    }
  }
}
    `;

/**
 * __useGetStatesByCountryQuery__
 *
 * To run a query within a React component, call `useGetStatesByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesByCountryQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetStatesByCountryQuery(baseOptions: Apollo.QueryHookOptions<GetStatesByCountryQuery, GetStatesByCountryQueryVariables> & ({ variables: GetStatesByCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>(GetStatesByCountryDocument, options);
      }
export function useGetStatesByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>(GetStatesByCountryDocument, options);
        }
export function useGetStatesByCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>(GetStatesByCountryDocument, options);
        }
export type GetStatesByCountryQueryHookResult = ReturnType<typeof useGetStatesByCountryQuery>;
export type GetStatesByCountryLazyQueryHookResult = ReturnType<typeof useGetStatesByCountryLazyQuery>;
export type GetStatesByCountrySuspenseQueryHookResult = ReturnType<typeof useGetStatesByCountrySuspenseQuery>;
export type GetStatesByCountryQueryResult = Apollo.QueryResult<GetStatesByCountryQuery, GetStatesByCountryQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($activeOnly: Boolean!, $first: Int, $after: String) {
  getCategories(activeOnly: $activeOnly, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      iconUrl
      active
      order
      names {
        id
        languageCode
        name
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCollaborationTypesDocument = gql`
    query GetCollaborationTypes($activeOnly: Boolean!, $first: Int, $after: String) {
  getCollaborationTypes(activeOnly: $activeOnly, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      iconUrl
      active
      order
      names {
        id
        languageCode
        name
      }
    }
  }
}
    `;

/**
 * __useGetCollaborationTypesQuery__
 *
 * To run a query within a React component, call `useGetCollaborationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollaborationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollaborationTypesQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCollaborationTypesQuery(baseOptions: Apollo.QueryHookOptions<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables> & ({ variables: GetCollaborationTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>(GetCollaborationTypesDocument, options);
      }
export function useGetCollaborationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>(GetCollaborationTypesDocument, options);
        }
export function useGetCollaborationTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>(GetCollaborationTypesDocument, options);
        }
export type GetCollaborationTypesQueryHookResult = ReturnType<typeof useGetCollaborationTypesQuery>;
export type GetCollaborationTypesLazyQueryHookResult = ReturnType<typeof useGetCollaborationTypesLazyQuery>;
export type GetCollaborationTypesSuspenseQueryHookResult = ReturnType<typeof useGetCollaborationTypesSuspenseQuery>;
export type GetCollaborationTypesQueryResult = Apollo.QueryResult<GetCollaborationTypesQuery, GetCollaborationTypesQueryVariables>;
export const SearchHashtagsDocument = gql`
    query SearchHashtags($query: String!, $first: Int, $after: String) {
  searchHashtags(query: $query, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      tag
      counts
    }
  }
}
    `;

/**
 * __useSearchHashtagsQuery__
 *
 * To run a query within a React component, call `useSearchHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHashtagsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchHashtagsQuery(baseOptions: Apollo.QueryHookOptions<SearchHashtagsQuery, SearchHashtagsQueryVariables> & ({ variables: SearchHashtagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHashtagsQuery, SearchHashtagsQueryVariables>(SearchHashtagsDocument, options);
      }
export function useSearchHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHashtagsQuery, SearchHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHashtagsQuery, SearchHashtagsQueryVariables>(SearchHashtagsDocument, options);
        }
export function useSearchHashtagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchHashtagsQuery, SearchHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchHashtagsQuery, SearchHashtagsQueryVariables>(SearchHashtagsDocument, options);
        }
export type SearchHashtagsQueryHookResult = ReturnType<typeof useSearchHashtagsQuery>;
export type SearchHashtagsLazyQueryHookResult = ReturnType<typeof useSearchHashtagsLazyQuery>;
export type SearchHashtagsSuspenseQueryHookResult = ReturnType<typeof useSearchHashtagsSuspenseQuery>;
export type SearchHashtagsQueryResult = Apollo.QueryResult<SearchHashtagsQuery, SearchHashtagsQueryVariables>;
export const AddHashtagDocument = gql`
    mutation AddHashtag($tag: String!) {
  addHashtag(tag: $tag) {
    id
    tag
    counts
  }
}
    `;
export type AddHashtagMutationFn = Apollo.MutationFunction<AddHashtagMutation, AddHashtagMutationVariables>;

/**
 * __useAddHashtagMutation__
 *
 * To run a mutation, you first call `useAddHashtagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHashtagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHashtagMutation, { data, loading, error }] = useAddHashtagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useAddHashtagMutation(baseOptions?: Apollo.MutationHookOptions<AddHashtagMutation, AddHashtagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHashtagMutation, AddHashtagMutationVariables>(AddHashtagDocument, options);
      }
export type AddHashtagMutationHookResult = ReturnType<typeof useAddHashtagMutation>;
export type AddHashtagMutationResult = Apollo.MutationResult<AddHashtagMutation>;
export type AddHashtagMutationOptions = Apollo.BaseMutationOptions<AddHashtagMutation, AddHashtagMutationVariables>;
export const GetMyProfilesDocument = gql`
    query GetMyProfiles {
  getMyProfiles {
    id
    owner {
      id
    }
    type
    email
    business {
      id
      profile {
        id
      }
      name
      url
      ownerName
      summary
      introduction
      phone
      coverPhoto {
        id
        uri
      }
      avatar {
        id
        uri
      }
      createdAt
      updatedAt
      categories {
        id
        names {
          id
          language
          languageCode
          name
        }
        iconUrl
        active
        order
      }
      media {
        id
        uri
      }
      countries {
        id
        name
      }
      states {
        id
        name
        country {
          id
          name
        }
        stateCode
      }
      tags {
        id
        tag
      }
      collaborationTypes {
        id
        iconUrl
        active
        order
        names {
          id
          language
          languageCode
          name
        }
      }
    }
    users {
      id
      user {
        id
        email
        name
        username
        dateOfBirth
        phone
        avatar {
          id
          uri
        }
      }
      role {
        id
        level
      }
      createdAt
      updatedAt
      deletedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMyProfilesQuery__
 *
 * To run a query within a React component, call `useGetMyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfilesQuery, GetMyProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProfilesQuery, GetMyProfilesQueryVariables>(GetMyProfilesDocument, options);
      }
export function useGetMyProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfilesQuery, GetMyProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProfilesQuery, GetMyProfilesQueryVariables>(GetMyProfilesDocument, options);
        }
export function useGetMyProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyProfilesQuery, GetMyProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProfilesQuery, GetMyProfilesQueryVariables>(GetMyProfilesDocument, options);
        }
export type GetMyProfilesQueryHookResult = ReturnType<typeof useGetMyProfilesQuery>;
export type GetMyProfilesLazyQueryHookResult = ReturnType<typeof useGetMyProfilesLazyQuery>;
export type GetMyProfilesSuspenseQueryHookResult = ReturnType<typeof useGetMyProfilesSuspenseQuery>;
export type GetMyProfilesQueryResult = Apollo.QueryResult<GetMyProfilesQuery, GetMyProfilesQueryVariables>;
export const GetMyCurrentProfileDocument = gql`
    query GetMyCurrentProfile($profileId: ID!) {
  getProfile(profileId: $profileId) {
    id
    business {
      id
      name
      avatar {
        id
        uri
      }
    }
  }
}
    `;

/**
 * __useGetMyCurrentProfileQuery__
 *
 * To run a query within a React component, call `useGetMyCurrentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCurrentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCurrentProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetMyCurrentProfileQuery(baseOptions: Apollo.QueryHookOptions<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables> & ({ variables: GetMyCurrentProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>(GetMyCurrentProfileDocument, options);
      }
export function useGetMyCurrentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>(GetMyCurrentProfileDocument, options);
        }
export function useGetMyCurrentProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>(GetMyCurrentProfileDocument, options);
        }
export type GetMyCurrentProfileQueryHookResult = ReturnType<typeof useGetMyCurrentProfileQuery>;
export type GetMyCurrentProfileLazyQueryHookResult = ReturnType<typeof useGetMyCurrentProfileLazyQuery>;
export type GetMyCurrentProfileSuspenseQueryHookResult = ReturnType<typeof useGetMyCurrentProfileSuspenseQuery>;
export type GetMyCurrentProfileQueryResult = Apollo.QueryResult<GetMyCurrentProfileQuery, GetMyCurrentProfileQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile($profileId: ID!) {
  getProfile(profileId: $profileId) {
    id
    owner {
      id
    }
    type
    email
    business {
      id
      profile {
        id
      }
      name
      url
      ownerName
      summary
      introduction
      phone
      coverPhoto {
        id
        uri
      }
      avatar {
        id
        uri
      }
      createdAt
      updatedAt
      categories {
        id
        names {
          id
          language
          languageCode
          name
        }
        iconUrl
        active
        order
      }
      media {
        id
        uri
      }
      countries {
        id
        name
      }
      states {
        id
        name
        country {
          id
          name
        }
        stateCode
      }
      tags {
        id
        tag
      }
      collaborationTypes {
        id
        iconUrl
        active
        order
        names {
          id
          language
          languageCode
          name
        }
      }
    }
    users {
      id
      user {
        id
        email
        name
        username
        dateOfBirth
        phone
        avatar {
          id
          uri
        }
      }
      role {
        id
        level
      }
      createdAt
      updatedAt
      deletedAt
    }
    picked
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables> & ({ variables: GetProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileSuspenseQueryHookResult = ReturnType<typeof useGetProfileSuspenseQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetBusinessProfilesDocument = gql`
    query GetBusinessProfiles($query: String, $categoryIds: [ID], $countryIds: [ID], $stateIds: [ID], $tagIds: [ID], $collaborationTypeIds: [ID], $first: Int, $after: String) {
  getBusinessProfiles(
    query: $query
    categoryIds: $categoryIds
    countryIds: $countryIds
    stateIds: $stateIds
    tagIds: $tagIds
    collaborationTypeIds: $collaborationTypeIds
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      owner {
        id
      }
      type
      email
      business {
        id
        profile {
          id
        }
        name
        url
        ownerName
        summary
        introduction
        phone
        coverPhoto {
          id
          uri
        }
        avatar {
          id
          uri
        }
        createdAt
        updatedAt
        categories {
          id
          names {
            id
            language
            languageCode
            name
          }
          iconUrl
          active
          order
        }
        media {
          id
          uri
        }
        countries {
          id
          name
        }
        states {
          id
          name
          country {
            id
            name
          }
          stateCode
        }
        tags {
          id
          tag
        }
        collaborationTypes {
          id
          iconUrl
          active
          order
          names {
            id
            language
            languageCode
            name
          }
        }
      }
      users {
        id
        user {
          id
          email
          name
          username
          dateOfBirth
          phone
          avatar {
            id
            uri
          }
        }
        role {
          id
          level
        }
        createdAt
        updatedAt
        deletedAt
      }
      picked
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetBusinessProfilesQuery__
 *
 * To run a query within a React component, call `useGetBusinessProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessProfilesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      categoryIds: // value for 'categoryIds'
 *      countryIds: // value for 'countryIds'
 *      stateIds: // value for 'stateIds'
 *      tagIds: // value for 'tagIds'
 *      collaborationTypeIds: // value for 'collaborationTypeIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBusinessProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>(GetBusinessProfilesDocument, options);
      }
export function useGetBusinessProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>(GetBusinessProfilesDocument, options);
        }
export function useGetBusinessProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>(GetBusinessProfilesDocument, options);
        }
export type GetBusinessProfilesQueryHookResult = ReturnType<typeof useGetBusinessProfilesQuery>;
export type GetBusinessProfilesLazyQueryHookResult = ReturnType<typeof useGetBusinessProfilesLazyQuery>;
export type GetBusinessProfilesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessProfilesSuspenseQuery>;
export type GetBusinessProfilesQueryResult = Apollo.QueryResult<GetBusinessProfilesQuery, GetBusinessProfilesQueryVariables>;
export const GetProfilePicksDocument = gql`
    query GetProfilePicks($profileId: ID!, $query: String, $categoryIds: [ID], $countryIds: [ID], $stateIds: [ID], $tagIds: [ID], $collaborationTypeIds: [ID], $first: Int, $after: String) {
  getProfilePicks(
    profileId: $profileId
    query: $query
    categoryIds: $categoryIds
    countryIds: $countryIds
    stateIds: $stateIds
    tagIds: $tagIds
    collaborationTypeIds: $collaborationTypeIds
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      owner {
        id
        name
        username
      }
      type
      email
      business {
        id
        profile {
          id
        }
        name
        url
        ownerName
        summary
        introduction
        phone
        coverPhoto {
          id
          uri
        }
        avatar {
          id
          uri
        }
        createdAt
        updatedAt
        categories {
          id
          names {
            id
            language
            languageCode
            name
          }
          iconUrl
          active
          order
        }
        media {
          id
          uri
        }
        countries {
          id
          name
        }
        states {
          id
          name
          country {
            id
            name
          }
          stateCode
        }
        tags {
          id
          tag
        }
        collaborationTypes {
          id
          iconUrl
          active
          order
          names {
            id
            language
            languageCode
            name
          }
        }
      }
      picked
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetProfilePicksQuery__
 *
 * To run a query within a React component, call `useGetProfilePicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePicksQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      query: // value for 'query'
 *      categoryIds: // value for 'categoryIds'
 *      countryIds: // value for 'countryIds'
 *      stateIds: // value for 'stateIds'
 *      tagIds: // value for 'tagIds'
 *      collaborationTypeIds: // value for 'collaborationTypeIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProfilePicksQuery(baseOptions: Apollo.QueryHookOptions<GetProfilePicksQuery, GetProfilePicksQueryVariables> & ({ variables: GetProfilePicksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePicksQuery, GetProfilePicksQueryVariables>(GetProfilePicksDocument, options);
      }
export function useGetProfilePicksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePicksQuery, GetProfilePicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePicksQuery, GetProfilePicksQueryVariables>(GetProfilePicksDocument, options);
        }
export function useGetProfilePicksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfilePicksQuery, GetProfilePicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfilePicksQuery, GetProfilePicksQueryVariables>(GetProfilePicksDocument, options);
        }
export type GetProfilePicksQueryHookResult = ReturnType<typeof useGetProfilePicksQuery>;
export type GetProfilePicksLazyQueryHookResult = ReturnType<typeof useGetProfilePicksLazyQuery>;
export type GetProfilePicksSuspenseQueryHookResult = ReturnType<typeof useGetProfilePicksSuspenseQuery>;
export type GetProfilePicksQueryResult = Apollo.QueryResult<GetProfilePicksQuery, GetProfilePicksQueryVariables>;
export const GetUnpickedCustomProfileCountDocument = gql`
    query GetUnpickedCustomProfileCount($pickerProfileId: ID!, $emails: [String]!) {
  getUnpickedCustomProfileCount(
    pickerProfileId: $pickerProfileId
    emails: $emails
  )
}
    `;

/**
 * __useGetUnpickedCustomProfileCountQuery__
 *
 * To run a query within a React component, call `useGetUnpickedCustomProfileCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpickedCustomProfileCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpickedCustomProfileCountQuery({
 *   variables: {
 *      pickerProfileId: // value for 'pickerProfileId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useGetUnpickedCustomProfileCountQuery(baseOptions: Apollo.QueryHookOptions<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables> & ({ variables: GetUnpickedCustomProfileCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>(GetUnpickedCustomProfileCountDocument, options);
      }
export function useGetUnpickedCustomProfileCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>(GetUnpickedCustomProfileCountDocument, options);
        }
export function useGetUnpickedCustomProfileCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>(GetUnpickedCustomProfileCountDocument, options);
        }
export type GetUnpickedCustomProfileCountQueryHookResult = ReturnType<typeof useGetUnpickedCustomProfileCountQuery>;
export type GetUnpickedCustomProfileCountLazyQueryHookResult = ReturnType<typeof useGetUnpickedCustomProfileCountLazyQuery>;
export type GetUnpickedCustomProfileCountSuspenseQueryHookResult = ReturnType<typeof useGetUnpickedCustomProfileCountSuspenseQuery>;
export type GetUnpickedCustomProfileCountQueryResult = Apollo.QueryResult<GetUnpickedCustomProfileCountQuery, GetUnpickedCustomProfileCountQueryVariables>;
export const CheckUniqueProfileEmailDocument = gql`
    query CheckUniqueProfileEmail($email: String!) {
  checkUniqueProfileEmail(email: $email)
}
    `;

/**
 * __useCheckUniqueProfileEmailQuery__
 *
 * To run a query within a React component, call `useCheckUniqueProfileEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUniqueProfileEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUniqueProfileEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckUniqueProfileEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables> & ({ variables: CheckUniqueProfileEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>(CheckUniqueProfileEmailDocument, options);
      }
export function useCheckUniqueProfileEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>(CheckUniqueProfileEmailDocument, options);
        }
export function useCheckUniqueProfileEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>(CheckUniqueProfileEmailDocument, options);
        }
export type CheckUniqueProfileEmailQueryHookResult = ReturnType<typeof useCheckUniqueProfileEmailQuery>;
export type CheckUniqueProfileEmailLazyQueryHookResult = ReturnType<typeof useCheckUniqueProfileEmailLazyQuery>;
export type CheckUniqueProfileEmailSuspenseQueryHookResult = ReturnType<typeof useCheckUniqueProfileEmailSuspenseQuery>;
export type CheckUniqueProfileEmailQueryResult = Apollo.QueryResult<CheckUniqueProfileEmailQuery, CheckUniqueProfileEmailQueryVariables>;
export const CreateBusinessProfileDocument = gql`
    mutation CreateBusinessProfile($businessInput: BusinessInput!, $roleId: ID!, $email: String!) {
  createBusinessProfile(
    businessInput: $businessInput
    roleId: $roleId
    email: $email
  ) {
    id
    owner {
      id
    }
    type
    email
    business {
      id
      profile {
        id
      }
      name
      url
      ownerName
      summary
      introduction
      phone
      coverPhoto {
        id
        uri
      }
      avatar {
        id
        uri
      }
      createdAt
      updatedAt
      categories {
        id
        names {
          id
          language
          languageCode
          name
        }
        iconUrl
        active
        order
      }
      media {
        id
        uri
      }
      countries {
        id
        name
      }
      states {
        id
        name
        country {
          id
          name
        }
        stateCode
      }
      tags {
        id
        tag
      }
      collaborationTypes {
        id
        iconUrl
        active
        order
        names {
          id
          language
          languageCode
          name
        }
      }
    }
    users {
      id
      user {
        id
        email
        name
        username
        dateOfBirth
        phone
        avatar {
          id
          uri
        }
      }
      role {
        id
        level
      }
      createdAt
      updatedAt
      deletedAt
    }
    createdAt
    updatedAt
  }
}
    `;
export type CreateBusinessProfileMutationFn = Apollo.MutationFunction<CreateBusinessProfileMutation, CreateBusinessProfileMutationVariables>;

/**
 * __useCreateBusinessProfileMutation__
 *
 * To run a mutation, you first call `useCreateBusinessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessProfileMutation, { data, loading, error }] = useCreateBusinessProfileMutation({
 *   variables: {
 *      businessInput: // value for 'businessInput'
 *      roleId: // value for 'roleId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateBusinessProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessProfileMutation, CreateBusinessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessProfileMutation, CreateBusinessProfileMutationVariables>(CreateBusinessProfileDocument, options);
      }
export type CreateBusinessProfileMutationHookResult = ReturnType<typeof useCreateBusinessProfileMutation>;
export type CreateBusinessProfileMutationResult = Apollo.MutationResult<CreateBusinessProfileMutation>;
export type CreateBusinessProfileMutationOptions = Apollo.BaseMutationOptions<CreateBusinessProfileMutation, CreateBusinessProfileMutationVariables>;
export const UpdateBusinessProfileDocument = gql`
    mutation UpdateBusinessProfile($profileId: ID!, $businessInput: BusinessInput!, $email: String!, $coverPhotoDeleted: Boolean, $avatarDeleted: Boolean) {
  updateBusinessProfile(
    profileId: $profileId
    businessInput: $businessInput
    email: $email
    coverPhotoDeleted: $coverPhotoDeleted
    avatarDeleted: $avatarDeleted
  ) {
    id
    owner {
      id
    }
    type
    email
    business {
      id
      profile {
        id
      }
      name
      url
      ownerName
      summary
      introduction
      phone
      coverPhoto {
        id
        uri
      }
      avatar {
        id
        uri
      }
      createdAt
      updatedAt
      categories {
        id
        names {
          id
          language
          languageCode
          name
        }
        iconUrl
        active
        order
      }
      media {
        id
        uri
      }
      countries {
        id
        name
      }
      states {
        id
        name
        country {
          id
          name
        }
        stateCode
      }
      tags {
        id
        tag
      }
      collaborationTypes {
        id
        iconUrl
        active
        order
        names {
          id
          language
          languageCode
          name
        }
      }
    }
    users {
      id
      user {
        id
        email
        name
        username
        dateOfBirth
        phone
        avatar {
          id
          uri
        }
      }
      role {
        id
        level
      }
      createdAt
      updatedAt
      deletedAt
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateBusinessProfileMutationFn = Apollo.MutationFunction<UpdateBusinessProfileMutation, UpdateBusinessProfileMutationVariables>;

/**
 * __useUpdateBusinessProfileMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessProfileMutation, { data, loading, error }] = useUpdateBusinessProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      businessInput: // value for 'businessInput'
 *      email: // value for 'email'
 *      coverPhotoDeleted: // value for 'coverPhotoDeleted'
 *      avatarDeleted: // value for 'avatarDeleted'
 *   },
 * });
 */
export function useUpdateBusinessProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessProfileMutation, UpdateBusinessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessProfileMutation, UpdateBusinessProfileMutationVariables>(UpdateBusinessProfileDocument, options);
      }
export type UpdateBusinessProfileMutationHookResult = ReturnType<typeof useUpdateBusinessProfileMutation>;
export type UpdateBusinessProfileMutationResult = Apollo.MutationResult<UpdateBusinessProfileMutation>;
export type UpdateBusinessProfileMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessProfileMutation, UpdateBusinessProfileMutationVariables>;
export const DeleteProfileMediaDocument = gql`
    mutation DeleteProfileMedia($profileId: ID!, $mediaIds: [ID]!) {
  deleteProfileMedia(profileId: $profileId, mediaIds: $mediaIds) {
    id
    owner {
      id
    }
    type
    email
    business {
      id
      profile {
        id
      }
      name
      url
      ownerName
      summary
      introduction
      phone
      coverPhoto {
        id
        uri
      }
      avatar {
        id
        uri
      }
      createdAt
      updatedAt
      categories {
        id
        names {
          id
          language
          languageCode
          name
        }
        iconUrl
        active
        order
      }
      media {
        id
        uri
      }
      countries {
        id
        name
      }
      states {
        id
        name
        country {
          id
          name
        }
        stateCode
      }
      tags {
        id
        tag
      }
      collaborationTypes {
        id
        iconUrl
        active
        order
        names {
          id
          language
          languageCode
          name
        }
      }
    }
    users {
      id
      user {
        id
        email
        name
        username
        dateOfBirth
        phone
        avatar {
          id
          uri
        }
      }
      role {
        id
        level
      }
      createdAt
      updatedAt
      deletedAt
    }
    createdAt
    updatedAt
  }
}
    `;
export type DeleteProfileMediaMutationFn = Apollo.MutationFunction<DeleteProfileMediaMutation, DeleteProfileMediaMutationVariables>;

/**
 * __useDeleteProfileMediaMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMediaMutation, { data, loading, error }] = useDeleteProfileMediaMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      mediaIds: // value for 'mediaIds'
 *   },
 * });
 */
export function useDeleteProfileMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfileMediaMutation, DeleteProfileMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfileMediaMutation, DeleteProfileMediaMutationVariables>(DeleteProfileMediaDocument, options);
      }
export type DeleteProfileMediaMutationHookResult = ReturnType<typeof useDeleteProfileMediaMutation>;
export type DeleteProfileMediaMutationResult = Apollo.MutationResult<DeleteProfileMediaMutation>;
export type DeleteProfileMediaMutationOptions = Apollo.BaseMutationOptions<DeleteProfileMediaMutation, DeleteProfileMediaMutationVariables>;
export const ToggleProfilePickDocument = gql`
    mutation ToggleProfilePick($pickerProfileId: ID!, $pickedProfileId: ID!, $picked: Boolean!) {
  toggleProfilePick(
    pickerProfileId: $pickerProfileId
    pickedProfileId: $pickedProfileId
    picked: $picked
  ) {
    id
    picked
  }
}
    `;
export type ToggleProfilePickMutationFn = Apollo.MutationFunction<ToggleProfilePickMutation, ToggleProfilePickMutationVariables>;

/**
 * __useToggleProfilePickMutation__
 *
 * To run a mutation, you first call `useToggleProfilePickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProfilePickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProfilePickMutation, { data, loading, error }] = useToggleProfilePickMutation({
 *   variables: {
 *      pickerProfileId: // value for 'pickerProfileId'
 *      pickedProfileId: // value for 'pickedProfileId'
 *      picked: // value for 'picked'
 *   },
 * });
 */
export function useToggleProfilePickMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProfilePickMutation, ToggleProfilePickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProfilePickMutation, ToggleProfilePickMutationVariables>(ToggleProfilePickDocument, options);
      }
export type ToggleProfilePickMutationHookResult = ReturnType<typeof useToggleProfilePickMutation>;
export type ToggleProfilePickMutationResult = Apollo.MutationResult<ToggleProfilePickMutation>;
export type ToggleProfilePickMutationOptions = Apollo.BaseMutationOptions<ToggleProfilePickMutation, ToggleProfilePickMutationVariables>;
export const CreateCustomProfilePicksDocument = gql`
    mutation CreateCustomProfilePicks($pickerProfileId: ID!, $customProfileInputs: [CustomProfileInput]!) {
  createCustomProfilePicks(
    pickerProfileId: $pickerProfileId
    customProfileInputs: $customProfileInputs
  )
}
    `;
export type CreateCustomProfilePicksMutationFn = Apollo.MutationFunction<CreateCustomProfilePicksMutation, CreateCustomProfilePicksMutationVariables>;

/**
 * __useCreateCustomProfilePicksMutation__
 *
 * To run a mutation, you first call `useCreateCustomProfilePicksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomProfilePicksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomProfilePicksMutation, { data, loading, error }] = useCreateCustomProfilePicksMutation({
 *   variables: {
 *      pickerProfileId: // value for 'pickerProfileId'
 *      customProfileInputs: // value for 'customProfileInputs'
 *   },
 * });
 */
export function useCreateCustomProfilePicksMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomProfilePicksMutation, CreateCustomProfilePicksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomProfilePicksMutation, CreateCustomProfilePicksMutationVariables>(CreateCustomProfilePicksDocument, options);
      }
export type CreateCustomProfilePicksMutationHookResult = ReturnType<typeof useCreateCustomProfilePicksMutation>;
export type CreateCustomProfilePicksMutationResult = Apollo.MutationResult<CreateCustomProfilePicksMutation>;
export type CreateCustomProfilePicksMutationOptions = Apollo.BaseMutationOptions<CreateCustomProfilePicksMutation, CreateCustomProfilePicksMutationVariables>;
export const PreRegisterDocument = gql`
    mutation PreRegister($customProfileInput: CustomProfileInput!) {
  preRegister(customProfileInput: $customProfileInput) {
    id
    type
    email
    business {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;
export type PreRegisterMutationFn = Apollo.MutationFunction<PreRegisterMutation, PreRegisterMutationVariables>;

/**
 * __usePreRegisterMutation__
 *
 * To run a mutation, you first call `usePreRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preRegisterMutation, { data, loading, error }] = usePreRegisterMutation({
 *   variables: {
 *      customProfileInput: // value for 'customProfileInput'
 *   },
 * });
 */
export function usePreRegisterMutation(baseOptions?: Apollo.MutationHookOptions<PreRegisterMutation, PreRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreRegisterMutation, PreRegisterMutationVariables>(PreRegisterDocument, options);
      }
export type PreRegisterMutationHookResult = ReturnType<typeof usePreRegisterMutation>;
export type PreRegisterMutationResult = Apollo.MutationResult<PreRegisterMutation>;
export type PreRegisterMutationOptions = Apollo.BaseMutationOptions<PreRegisterMutation, PreRegisterMutationVariables>;
export const GetMySnsChannelsDocument = gql`
    query GetMySnsChannels {
  getMySnsChannels {
    id
    type
    name
    thumbnailUri
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMySnsChannelsQuery__
 *
 * To run a query within a React component, call `useGetMySnsChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySnsChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySnsChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySnsChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>(GetMySnsChannelsDocument, options);
      }
export function useGetMySnsChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>(GetMySnsChannelsDocument, options);
        }
export function useGetMySnsChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>(GetMySnsChannelsDocument, options);
        }
export type GetMySnsChannelsQueryHookResult = ReturnType<typeof useGetMySnsChannelsQuery>;
export type GetMySnsChannelsLazyQueryHookResult = ReturnType<typeof useGetMySnsChannelsLazyQuery>;
export type GetMySnsChannelsSuspenseQueryHookResult = ReturnType<typeof useGetMySnsChannelsSuspenseQuery>;
export type GetMySnsChannelsQueryResult = Apollo.QueryResult<GetMySnsChannelsQuery, GetMySnsChannelsQueryVariables>;
export const AddSnsChannelDocument = gql`
    mutation AddSnsChannel($refreshToken: String!, $snsType: SNSType!) {
  addSnsChannel(refreshToken: $refreshToken, snsType: $snsType) {
    id
    user {
      id
    }
    type
    name
    refreshToken
    accessToken
    thumbnailUri
    createdAt
    updatedAt
  }
}
    `;
export type AddSnsChannelMutationFn = Apollo.MutationFunction<AddSnsChannelMutation, AddSnsChannelMutationVariables>;

/**
 * __useAddSnsChannelMutation__
 *
 * To run a mutation, you first call `useAddSnsChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSnsChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSnsChannelMutation, { data, loading, error }] = useAddSnsChannelMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *      snsType: // value for 'snsType'
 *   },
 * });
 */
export function useAddSnsChannelMutation(baseOptions?: Apollo.MutationHookOptions<AddSnsChannelMutation, AddSnsChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSnsChannelMutation, AddSnsChannelMutationVariables>(AddSnsChannelDocument, options);
      }
export type AddSnsChannelMutationHookResult = ReturnType<typeof useAddSnsChannelMutation>;
export type AddSnsChannelMutationResult = Apollo.MutationResult<AddSnsChannelMutation>;
export type AddSnsChannelMutationOptions = Apollo.BaseMutationOptions<AddSnsChannelMutation, AddSnsChannelMutationVariables>;
export const SearchTagsDocument = gql`
    query SearchTags($query: String!, $first: Int, $after: String) {
  searchTags(query: $query, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      tag
      count
    }
  }
}
    `;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables> & ({ variables: SearchTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
      }
export function useSearchTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTagsSuspenseQuery>;
export type SearchTagsQueryResult = Apollo.QueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export const GetMyUserDocument = gql`
    query GetMyUser {
  getMyUser {
    id
    email
    name
    username
    dateOfBirth
    phone
    resignReason
    snsChannels {
      id
      type
    }
    ownedProfiles {
      id
      business {
        id
        name
        avatar {
          id
          uri
        }
        categories {
          id
          iconUrl
          names {
            id
            language
            name
            languageCode
          }
        }
      }
    }
    profiles {
      id
      profile {
        business {
          id
          name
          avatar {
            id
            uri
          }
          categories {
            id
            iconUrl
            names {
              id
              language
              name
              languageCode
            }
          }
        }
      }
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetMyUserQuery__
 *
 * To run a query within a React component, call `useGetMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUserQuery(baseOptions?: Apollo.QueryHookOptions<GetMyUserQuery, GetMyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument, options);
      }
export function useGetMyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUserQuery, GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export function useGetMyUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyUserQuery, GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export type GetMyUserQueryHookResult = ReturnType<typeof useGetMyUserQuery>;
export type GetMyUserLazyQueryHookResult = ReturnType<typeof useGetMyUserLazyQuery>;
export type GetMyUserSuspenseQueryHookResult = ReturnType<typeof useGetMyUserSuspenseQuery>;
export type GetMyUserQueryResult = Apollo.QueryResult<GetMyUserQuery, GetMyUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $password: String!) {
  createUser(email: $email, password: $password) {
    id
    email
    name
    username
    dateOfBirth
    phone
    avatar {
      id
      uri
    }
    resignReason
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation UpdateMyUser($userInput: UserInput!) {
  updateMyUser(userInput: $userInput) {
    id
    email
    name
    username
    dateOfBirth
    phone
    avatar {
      id
      uri
    }
    resignReason
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type UpdateMyUserMutationFn = Apollo.MutationFunction<UpdateMyUserMutation, UpdateMyUserMutationVariables>;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export const ResignDocument = gql`
    mutation Resign($reason: String) {
  resign(reason: $reason)
}
    `;
export type ResignMutationFn = Apollo.MutationFunction<ResignMutation, ResignMutationVariables>;

/**
 * __useResignMutation__
 *
 * To run a mutation, you first call `useResignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resignMutation, { data, loading, error }] = useResignMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResignMutation(baseOptions?: Apollo.MutationHookOptions<ResignMutation, ResignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResignMutation, ResignMutationVariables>(ResignDocument, options);
      }
export type ResignMutationHookResult = ReturnType<typeof useResignMutation>;
export type ResignMutationResult = Apollo.MutationResult<ResignMutation>;
export type ResignMutationOptions = Apollo.BaseMutationOptions<ResignMutation, ResignMutationVariables>;